// Phase JB.2 — Escalating menu pure logic (client mirror).
//
// Mirrors supabase/functions/_shared/escalating-menu.ts so the React
// hook can call the same calculation without importing Deno code.
// Tests live in supabase/functions/_shared/escalating-menu.test.ts —
// duplicated here only to keep the bundle Deno-import-free.
//
// N08 (no manipulative menu reveals): unlockCopy is celebratory only.

export const TIER_A_UNLOCK_CAP = 3;

export function tierAUnlocksForWeek(weekIndex: number): number {
  if (!Number.isFinite(weekIndex) || weekIndex < 1) return 0;
  if (weekIndex === 1) return 0;
  if (weekIndex === 2) return 1;
  if (weekIndex === 3) return 2;
  return TIER_A_UNLOCK_CAP;
}

export function unlockCopy(weekIndex: number): string {
  const n = tierAUnlocksForWeek(weekIndex);
  if (n === 0) return "Tier-A signals unlock from week 2 onwards";
  return `Week ${weekIndex} — ${n} tier-A signal${n === 1 ? "" : "s"} unlocked for you`;
}
